<template>
  <div>
    <el-tabs>
      <el-tab-pane label="企业上报">
        <components :is="componentShow" />
      </el-tab-pane> 
    </el-tabs>  
  </div>
</template>
<script>
import request from '@/utils/request'
import ImgUpload from '@/components/ImgUpload'
import partrGroupJsReport from './components/partrGroup_js_report'
import partyGroupLnReport from './components/partyGroup_ln_report'
import partyGroupGdReport from './components/partyGroup_gd_report'
import {
    isURL,
    isPartyGroupPrefix,
    isBusinessLicenseImgNum,
} from '@/utils/validate4Form'
export default {
    name: 'SysSetting',
    components: {
        ImgUpload,
        partyGroupLnReport,
        partyGroupGdReport,
        partrGroupJsReport
    },
    data() {
        return {
            companyCode: '',
            isDetail: false,
            componentShow:'partyGroupLnReport',
            form: {},
            rules: {
                groupName: [
                    {
                        required: true,
                        message: '请输入公司名称：机构/网点/入住企业',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 256,
                        message: '长度在 1 到 256 个字符',
                        trigger: 'blur',
                    },
                ],
                groupNameLocal: [
                    {
                        required: true,
                        message: '请输入公司简称3-7字符',
                        trigger: 'blur',
                    },
                    {
                        min: 3,
                        max: 7,
                        message: '长度在 3 到 7 个字符',
                        trigger: 'blur',
                    },
                ],
                organizationCode: [
                    {
                        required: true,
                        message: '请输入公司简称码',
                        trigger: 'blur',
                    },
                    { validator: isPartyGroupPrefix, trigger: 'blur' },
                    {
                        min: 2,
                        max: 6,
                        message: '长度在 2 到 6 个字符',
                        trigger: 'blur',
                    },
                ],
                wwwUrl: [
                    {
                        required: true,
                        message: '请输入公司网址',
                        trigger: 'blur',
                    },
                    { validator: isURL, trigger: 'blur' },
                    {
                        min: 1,
                        max: 255,
                        message: '长度在 1 到 255 个字符',
                        trigger: 'blur',
                    },
                ],
                address: [
                    {
                        required: true,
                        message: '请输入公司地址',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 255,
                        message: '长度在 1 到 255 个字符',
                        trigger: 'blur',
                    },
                ],
                telephone: [
                    {
                        required: true,
                        message: '请输入400客服电话',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 16,
                        message: '长度在 1 到 16 个字符',
                        trigger: 'blur',
                    },
                ],
                //  telephone: [
                //   { required: true, message: '请输入400客服电话', trigger: 'blur' },
                //   {
                //     validator(rule, value, callback) {
                //         validatePhone(value)?callback():validateTelephone(value)?callback():callback(new Error('电话格式有误'))
                //     },
                //     trigger: 'blur',
                //   },
                //   { min: 1, max: 16, message: "长度在 1 到 16 个字符", trigger: "blur" }
                // ],
                uniformSocialCreditCode: [
                    {
                        required: true,
                        message: '请输入统一社会信用代码',
                        trigger: 'blur',
                    },
                    { validator: isBusinessLicenseImgNum, trigger: 'blur' },
                    {
                        min: 1,
                        max: 255,
                        message: '长度在 1 到 255 个字符',
                        trigger: 'blur',
                    },
                ],
                permitNumber: [
                    {
                        required: true,
                        message: '请输入道路运输经营许可证编号',
                        trigger: 'blur',
                    },
                    {
                        min: 1,
                        max: 50,
                        message: '长度在 1 到 50 个字符',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    created() {
        // 获取路由
        this.companyCode = this.$route.query.code || ''
        this.componentShow = this.$route.query.componentShow || ''
        this.isDetail = this.$route.query.prefix == 'detail' ? true : false
        this.getInfo(this.companyCode)
    },

    methods: {
        getInfo(code) {
            return request({
                url: `/ntocc-basic-api/partyGroup/${code}`,
                method: 'get',
            }).then((response) => {
                if (response.data) {
                    this.form = response.data
                }
            })
        },
        creditMis() {
            return request({
                url: `/ntocc-basic-api/partyGroup/caculateCompanySeal`,
                method: 'post',
                params: {
                    uniformSocialCreditCode: this.form.uniformSocialCreditCode,
                },
            }).then((response) => {
                this.form.misUrl = response.data
            })
        },
        // 提交
        funcSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    const data = this.form
                    const rLoading = this.openLoading()
                    if (data.code) {
                        request({
                            url: '/ntocc-basic-api/partyGroup',
                            method: 'put',
                            params: data,
                        }).then((response) => {
                            this.getInfo()
                            rLoading.close()
                            this.$message({
                                message: response.msg,
                                type: 'success',
                            })
                        })
                    } else {
                        request({
                            url: '/ntocc-basic-api/partyGroup',
                            method: 'post',
                            params: data,
                        }).then((response) => {
                            this.getInfo()
                            rLoading.close()
                            this.$message({
                                message: response.msg,
                                type: 'success',
                            })
                        })
                    }
                } else {
                    return false
                }
            })
        },
        funcEdit() {
          this.isDetail = false;
        }
    },
}
</script>
<style scoped>
 .first-title {
   margin:20px 0;
   font-size:18px;
 }


  .first-title::before {
  content: "";
  height: 15px;
  width: 2px;
  background-color: #ff7f21;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
